<template>
	<div class="vld-parent">
	<loading :active="loading" color="#D9F7C5" loader="bars"/>
	</div>
<Card>
    <template #content>
		<div class="p-m-500">
			<p>Seleccionar el perfil de importación de lecturas y el archivo a procesar:</p>
            <Divider />
			<div class="p-fluid p-formgrid p-grid">
				<div class="p-fluid p-field p-ml-3">
					<label for="perfil" class="p-text-bold">Perfil de Importación</label>
					<Dropdown v-model="id_perfil" :options="perfiles" optionLabel="perfil" optionValue="id_perfil" @change="actualizarIdentificadores($event)"/>
				</div>	
			</div>	
			<Divider />
			<div class="p-fluid p-formgrid p-grid">		
				<div class="p-field p-ml-3">
					<label for="archivo" class="p-text-bold">Archivo de Lecturas</label>
					<!-- @upload="goNextPage"  -->
					<FileUpload mode="advanced" :multiple="false" ref="updArchivo" :customUpload="true" :showCancelButton="true" :showUploadButton="false" @uploader="cargarArchivo($event)" chooseLabel="Seleccionar Archivo..." accept=".json,application/json,text/*" cancelLabel="Cancelar"/>
				</div>	
			</div>	
		</div>
    </template>
    <template #footer>
		<div class="p-d-flex p-jc-end">
		<Button label="Siguiente" icon="pi pi-angle-right" @click="nextPage()"  :disabled="!puedeContinuar" icon-pos="right"/>	
		</div>
    </template>
</Card>	
<Dialog v-model:visible="verificandoDlg" :showHeader="true" :modal="true" :closable="false">			
	<div class="flex align-content-center flex-wrap card-container" :style="{width: '500px', height: '250'}">
		<div class="p-d-flex p-ai-center p-jc-center p-mb-2">
			<img src="/assets/layout/images/view.gif" width="64" height="64"/>
		</div>		
		<div class="p-d-flex p-ai-center p-jc-center p-text-bold">
			<div class="text-lg">Por favor espere un minuto mientras verificamos el archivo y su registros..</div>
		</div>
	</div>
</Dialog>
</template>
<script>
import Loading from 'vue-loading-overlay';
import MdsService from '../../../service/mds.service';
import { CURRENT_APP_MODE } from '../../../service/constants';
import Divider from 'primevue/divider';

export default {
    name: 'ContImpSeleccionPerfil',
	props: {
		formData: {
			type: Object,
			Default() {
				return {
					id_perfil: '',
					id_moneda: '',
					moneda_simbolo: '',
					tipo: 0,
					procesados: 0,
					total_procesado: 0.0,
					errores: false,
					archivo: '',
					lecturas: []					
				}
			}
		}
	},
	components: {
		Divider, Loading
	},
	data() {        
        return {
            appMode: CURRENT_APP_MODE,
            verificandoDlg: false,
			archivo: null,
            perfiles: [],
			id_perfil: this.formData.id_perfil,	
			id_moneda: this.formData.id_moneda,	
			moneda_simbolo: this.formData.moneda_simbolo,	
			tipo: this.formData.tipo,
			procesados: this.formData.procesados,
			total_procesado: this.formData.total_procesado,					
			errores: this.formData.errores,
			id_empleado: this.$store.state.auth.currentAppCtx.id_empleado,	
			procesandoDlg: false,
			loading: false
        }
    },
    mounted() {
		this.loading = true;

		MdsService.getContadoresPerfilesImportacion(this.$store.state.auth.currentAppCtx).then(
			data => {
				this.perfiles = data;
				if(this.perfiles.length > 0) {
					this.id_perfil = this.perfiles[0].id_perfil;
					this.id_moneda = this.perfiles[0].id_moneda;
					this.tipo = this.perfiles[0].id_contador_tipo;
					this.moneda_simbolo = this.perfiles[0].moneda_simbolo;		
				}

				this.loading = false;
			}
		).catch(
			data => {
				this.loading = false;
				this.$toast.add({severity:'error', summary: 'Error', detail: data, life: 3000})
			}
		)		            
    },
	computed: {
		puedeContinuar(){
			if ((this.id_perfil) && (this.$refs.updArchivo.files.length > 0))
				return true
			else
				return false;
		}
	},
    methods: {
		async cargarArchivo(e) {
			this.verificandoDlg = true;
			try {
				var doc =  e.files[0];

				var complemento = {
					id_perfil: this.id_perfil,
					id_empleado: this.id_empleado
				};
				
				let movs = await MdsService.cargarArchivoLecturas(this.$store.state.auth.currentAppCtx, complemento, doc);
				let errores = movs.filter(e => {return e.error});

				let formData = {
					id_perfil: this.id_perfil,
					id_moneda: this.id_moneda,
					moneda_simbolo:	this.moneda_simbolo,
            		tipo: this.tipo,
            		procesados: this.procesados,
            		total_procesado: this.total_procesado,
					archivo: this.archivo,
					errores: (errores.length > 0),
					lecturas: (errores.length==0?movs:errores)
				};

			   	this.$emit('nextPage', {condiciones: formData, pageIndex: 0});
				
				this.verificandoDlg = false;
			} catch (err) {
				this.verificandoDlg = false;
				this.$toast.add({severity:'error', summary: 'Error', detail: err, life: 3000})
			}	
		},
		nextPage(){
			this.$refs.updArchivo.upload();
		}
    }
}
</script>

<style scoped lang="scss">
::v-deep(b) {
    display: block;
}

::v-deep(.p-card-body) {
    padding: 2rem;
}
</style>